import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/components/app/shell/page-header";
import { useFacility } from "@/lib/facility/facility";
import { LiveTestCard } from "./-components/live-test-card";
import { RunsTable } from "./-components/runs-table";
import { TextRehearsalCard } from "./-components/text-rehearsal-card";
import { OneBuildingCard } from "@/components/app/workspace/one-building-card";

export const Route = createFileRoute("/_authenticated/_front-desk/sarah/agent-test/")({
  component: AgentTest,
});

const META =
  "Ring the front desk from this machine and hear what a caller hears. Nothing is dialled and no resident is contacted; a transfer decision is recorded rather than placed.";

/** Live needs ONE building (an agent belongs to a community) while history follows the switcher, so
 * the live card says so rather than disappearing. */
function AgentTest() {
  const { facilityId } = useFacility();
  const realFacility = facilityId === "all" ? null : facilityId;

  return (
    <>
      <PageHeader title="Agent test" meta={META} />

      {realFacility ? (
        // Keyed by building: switching unmounts the card, taking its microphone and billing model
        // session with it.
        <>
          <LiveTestCard key={realFacility} facilityId={realFacility} />
          {/* Keyed the same way: a fresh community is a fresh conversation. */}
          <TextRehearsalCard key={`text-${realFacility}`} facilityId={realFacility} />
        </>
      ) : (
        <OneBuildingCard prompt="Choose a building to run a test. Each one answers with its own prompt, so a test means something only against one of them. Finished tests for every building are below." />
      )}

      <div className="space-y-2">
        <h2 className="text-lg font-medium">Finished tests</h2>
        <RunsTable facilityId={facilityId} />
      </div>
    </>
  );
}
